import { render, staticRenderFns } from "./OwnNavigationDrawer.vue?vue&type=template&id=cdce447c&scoped=true"
import script from "./OwnNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./OwnNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./OwnNavigationDrawer.vue?vue&type=style&index=0&id=cdce447c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce447c",
  null
  
)

export default component.exports